export function getUserInitials(user) {
  if (user?.name) {
    return user.name
      .split(' ')
      .map((w) => w[0])
      .join('')
      .slice(0, 2)
      .toUpperCase()
  }
  return user?.email?.[0]?.toUpperCase() ?? '?'
}
